import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/nav';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4 group whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg font-bold">
                <i className="ri-global-line"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">亚洲免费在线</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              亚洲优质免费网络资源首选平台
              <br />
              无门槛·全面分类·持续更新
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="RSS">
                <i className="ri-rss-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">资源分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">更多分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.slice(4).map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速链接</h4>
            <ul className="space-y-2.5">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 亚洲免费在线 — 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">使用条款</a>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}